import { useEffect } from "react";

/**
 * Gọi callback sau khi giá trị thay đổi và debounce qua delay (ms)
 * @param effect - callback cần chạy sau debounce (ví dụ: gọi API)
 * @param deps - mảng dependency (ví dụ: [search, filter])
 * @param delay - thời gian debounce (ms)
 */
export function useDebounceEffect(
    effect: () => void | (() => void),
    deps: any[],
    delay = 300
) {
    useEffect(() => {
        const handler = setTimeout(() => {
            effect();
        }, delay);

        // cleanup nếu deps thay đổi trước khi hết delay
        return () => clearTimeout(handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps, delay]);
}
